import apiService from '../service/api-service';

/**
 * Downloads a PDF from the specified API endpoint.
 *
 * @param url - The base URL of the API endpoint.
 * @param params - An object representing query parameters to append to the URL.
 * @param fileName - The name of the file to be downloaded (defaults to 'download.pdf').
 */
export async function downloadPDF(
  url: string,
  params: Record<string, string> = {},
  fileName: string = 'download.pdf'
): Promise<void> {
  try {
    // Make a GET request using apiService to ensure the auth token is attached
    const response = await apiService.get<Blob>(url, params, {
      headers: {
        Accept: 'application/pdf',
      },
      responseType: 'blob'
    });

    const blob = response.data;

    // Create an object URL from the Blob.
    const objectUrl = window.URL.createObjectURL(blob);

    // Create a temporary anchor element and trigger the download.
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // Clean up: remove the anchor and revoke the object URL.
    a.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error('Error downloading the PDF:', error);
  }
}
